import React from 'react'
import _ from 'lodash'
import classNames from 'classnames'

import ScrollArea from 'react-scrollbar'
import {LunaHints} from '../lunahints.component'

export class LunaHelpModal extends React.Component {
    constructor(props) {
        super(props)

        let _isMounted = false

        _.bindAll(this,
            'showContent',
            'setContent',
            'getContent',
            'updateScrollElement'
        )
    }

    componentDidMount() {
        let self = this
        this._isMounted = true
        // need to wait for window to finish loading to call the $.fancybox
        if (this.props.showHelp) {
            this.whenAvailable(function (t) {
                self.showContent()
                self.updateScrollElement()
            })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        let self = this
        if (this.props.showHelp && this._isMounted) {
            this.whenAvailable(function (t) {
                self.showContent()
                self.updateScrollElement()
            })
        }
    }

    whenAvailable(callback) {
        let self = this
        if (typeof $.fancybox === 'undefined') {
            setTimeout(function () {
                self.whenAvailable(callback)
            }, 100) // wait 100 ms
        } else {
            callback()
        }
    }

    updateScrollElement() {
        let _this = this
        window.requestAnimationFrame(function () {
            $('.modal-scroll-area').each(function () {
                let nH = $(this).height()
                $(this).parent().height(nH)
            })
        })
    }

    showContent() {
        let self = this
        let temp = this.setContent()
        // baseTpl is the standard but with a luna icon for close
        $.fancybox.open(
            temp,
            {
                baseClass: 'luna-help-modal',
                toolbar: false,
                infobar: false,
                closeTpl: '<button data-fancybox-close class="fancybox-close-small"><i class="icon-close"></i></button>',
                onComplete: function (instance, slide) {
                    $('.fancybox-bg').on('click', function () {
                        $.fancybox.close()
                    })
                },
                afterOpen: function () {
                    self.updateScrollElement()
                },
                beforeMove: function () {
                    self.updateScrollElement()
                },
                afterClose: function () {
                    // $('.fancybox-bg').unbind('click')
                    self.props.onToggleHelp()
                }
            }
        )
    }

    setContent() {
        let tArray = []
        $('.slide-content').each(function () {
            let tSlide = {
                src: '#' + $(this).attr('id'),
                type: 'inline'
            }
            tArray.push(tSlide)
        })
        return tArray
    }

    getContent() {
        let prevBtn = <button className="btn btn-flex slide-prev" data-fancybox-previous title="Prev"><i
            className="icon-arrow_left_b"/>PREVIOUS TIP</button>
        let nextBtn = <button className="btn btn-flex slide-next btn-rose" data-fancybox-next title="Next">NEXT TIP<i
            className="icon-arrow_right_b"/></button>


        if (!this.props.content) {
            switch (this.props.type) {
                case 'luna-trip':
                    // TODO: check for mobile, or do we just update LunaHints to have mobile content?
                    if (_isMobile) {
                        // mobile
                        return null
                    } else {
                        // Not mobile
                        return (
                            <div>
                                <div id="slide-1" className="slide-content">
                                    <ScrollArea
                                    speed={0.8}
                                    className="area"
                                    contentClassName="modal-scroll-area"
                                    horizontal={false}>
                                        <div className="slide-upper">
                                            <div className="title-block">
                                                <div className="tip-label"/>
                                                <h1>Your trip timeline.</h1>
                                                <p>
                                        The outline at the top of your page represents the days in your itinerary. Use
                                        this section to organize the most important elements of your trip. You can
                                        easily design your trip with the following features.
                                                </p>
                                            </div>
                                            <div className="btn-block"/>
                                        </div>
                                        <div className="slide-lower">
                                            <div className="luna-hints-container flex-row">
                                                <div className="luna-hint-block">
                                                    <img src="/assets/img/layout/luna-planner-guide-01.png"/>
                                                    <h2>Select To Get Started</h2>
                                                    <p>
                                          Each block represents a day in your itinerary. Click on any day to get started
                                          with a destination.
                                                    </p>
                                                </div>
                                                <div className="luna-hint-block">
                                                    <img src="/assets/img/layout/luna-planner-guide-02.png"/>
                                                    <h2>Drag and Drop</h2>
                                                    <p>
                                          Want to change the order of your trip? Not a problem. Drag and drop the order
                                          within the timeline.
                                                    </p>
                                                </div>
                                                <div className="luna-hint-block">
                                                    <img src="/assets/img/layout/luna-planner-guide-03.png"/>
                                                    <h2>Adjust the length</h2>
                                                    <p>
                                          Stay longer (or shorter) in any destination by selecting and resizing for your
                                          desired length.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </ScrollArea>
                                </div>
                            </div>
                        )
                    }
                    break
                case 'luna-timer':
                    // No difference in mobile and desktop
                    let lunaLink = '/create-trip?luna-slug=' + this.props.lunatrip.get('slug')
                    return (
                        <div>
                            <div id="slide-1" className="slide-content">
                                <ScrollArea
                                speed={0.8}
                                className="area"
                                contentClassName="modal-scroll-area"
                                horizontal={false}>
                                    <div className="slide-lower">
                                        <h1>Make this trip your own! </h1>
                                        <p className="p-center">Choose an option below to save your changes and invite others to
                                  plan with you.</p>
                                        <div className="flex-row flex-row-block">
                                            <a href={lunaLink} className="btn btn-medium btn-blue">CUSTOMIZE TRIP</a>
                                        </div>
                                        <div>
                                            <a href="/create-trip" className="btn-skip">Create my own trip</a>
                                        </div>
                                    </div>
                                </ScrollArea>
                            </div>
                        </div>
                    )
                    break
                case 'welcome':
                    if (_isMobile) {
                        // Mobile
                        return null
                    } else {
                        // Not mobile
                        return (
                            <div>
                                <div id="slide-1" className="slide-content">
                                    <ScrollArea
                                    speed={0.8}
                                    className="area"
                                    contentClassName="modal-scroll-area"
                                    horizontal={false}>
                                        <div className="slide-upper slide-upper-block">
                                            <div className="title-block">
                                                <h1>Welcome to your trip!</h1>
                                                <p>
                                        We can't wait to see your amazing vacation come to life. We've prepared a quick
                                        3-step tutorial to walk you through Luna's most important features.
                                                </p>
                                            </div>
                                            <div className="btn-block"/>
                                        </div>
                                        <div className="slide-lower">
                                            <p className="p-center">
                                      If at any point you get stuck or have any additional questions, contact <a
                                        href="mailto:support@lunamoons.com">Support</a> or use the chat feature on the
                                      bottom right of your page.
                                            </p>
                                            <br/>
                                            <button data-fancybox-next className="btn btn-medium btn-blue">Get Started!</button>
                                        </div>
                                    </ScrollArea>
                                </div>
                                <div id="slide-2" className="slide-content">
                                    <ScrollArea
                                    speed={0.8}
                                    className="area"
                                    contentClassName="modal-scroll-area"
                                    horizontal={false}>
                                        <div className="slide-upper">
                                            <div className="title-block">
                                                <div className="tip-label">Tip 1</div>
                                                <h1>Your trip timeline.</h1>
                                                <p>
                                        The outline at the top of your page represents the days in your itinerary. Use
                                        this section to organize the most important elements of your trip. You can
                                        easily design your trip with the following features.
                                                </p>
                                            </div>
                                            <div className="btn-block">
                                                {nextBtn}
                                            </div>
                                        </div>
                                        <div className="slide-lower">
                                            <div className="luna-hints-container flex-row">
                                                <div className="luna-hint-block">
                                                    <img src="/assets/img/layout/luna-planner-guide-01.png"/>
                                                    <h2>Select To Get Started</h2>
                                                    <p>
                                          Each block represents a day in your itinerary. Click on any day to get started
                                          with a destination.
                                                    </p>
                                                </div>
                                                <div className="luna-hint-block">
                                                    <img src="/assets/img/layout/luna-planner-guide-02.png"/>
                                                    <h2>Drag and Drop</h2>
                                                    <p>
                                          Want to change the order of your trip? Not a problem. Drag and drop the order
                                          within the timeline.
                                                    </p>
                                                </div>
                                                <div className="luna-hint-block">
                                                    <img src="/assets/img/layout/luna-planner-guide-03.png"/>
                                                    <h2>Adjust the length</h2>
                                                    <p>
                                          Stay longer (or shorter) in any destination by selecting and resizing for your
                                          desired length.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </ScrollArea>
                                </div>

                                <div id="slide-3" className="slide-content">
                                    <ScrollArea
                                    speed={0.8}
                                    className="area"
                                    contentClassName="modal-scroll-area"
                                    horizontal={false}>
                                        <div className="slide-upper">
                                            <div className="title-block">
                                                <div className="tip-label">Tip 2</div>
                                                <h1>Planning together is easy.</h1>
                                                <p>
                                        Luna is designed to help you plan your trip together. Collaborate with
                                        co-travelers with the following features and plan when and the way you want to.
                                                </p>
                                            </div>
                                            <div className="btn-block">
                                                {nextBtn}
                                                {prevBtn}
                                            </div>
                                        </div>
                                        <div className="slide-lower">
                                            <div className="luna-hints-container flex-row">
                                                <div className="luna-hint-block">
                                                    <img src="/assets/img/layout/luna-collab-guide-01.png"/>
                                                    <h2>Invite Co-Travelers</h2>
                                                    <p>
                                          Add additional travelers to your trip by clicking on the plus sign on the
                                          right-side of your page.
                                                    </p>
                                                </div>
                                                <div className="luna-hint-block">
                                                    <img src="/assets/img/layout/luna-collab-guide-02.png"/>
                                                    <h2>Co-Traveler Status</h2>
                                                    <p>
                                          Co-travelers currently online will have a blue user icon, enabling real-time
                                          collaboration.
                                                    </p>
                                                </div>
                                                <div className="luna-hint-block">
                                                    <img src="/assets/img/layout/luna-collab-guide-03.png"/>
                                                    <h2>Chat it Up</h2>
                                                    <p>
                                          Click on the chat bubble on the bottom bar to start chatting with your
                                          co-traveler or a Luna Planner.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </ScrollArea>
                                </div>
                                <div id="slide-4" className="slide-content">
                                    <ScrollArea
                                    speed={0.8}
                                    className="area"
                                    contentClassName="modal-scroll-area"
                                    horizontal={false}>
                                        <div className="slide-upper">
                                            <div className="title-block">
                                                <div className="tip-label">Tip 3</div>
                                                <h1>We've got your back!</h1>
                                                <p>
                                        Luna is available along every step of the way of the travel planning process.
                                                </p>
                                            </div>
                                            <div className="btn-block">
                                                <button className="btn btn-flex slide-next btn-rose" data-fancybox-close
                                                        title="Close">Start Exploring!<i className="icon-arrow_right_b"/>
                                                </button>
                                                {prevBtn}
                                            </div>
                                        </div>
                                        <div className="slide-lower">
                                            <div className="luna-hints-container flex-row">
                                                <div className="luna-hint-block">
                                                    <img src="/assets/img/layout/luna-guide-01.png"/>
                                                    <h2>@Luna via Chat</h2>
                                                    <p>
                                          Use @luna in the chat tool for any questions or assistance in using the
                                          planner.
                                                    </p>
                                                </div>
                                                <div className="luna-hint-block">
                                                    <img src="/assets/img/layout/luna-guide-03.png"/>
                                                    <h2>Luna Assist</h2>
                                                    <p>
                                          Use the Luna Assist button to submit a special request or for more personal
                                          guidance from a Luna Planner.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </ScrollArea>
                                </div>
                            </div>
                        )
                    }
                    break
            }
        } else {
            <div id="slide-1" className="slide-content">{this.props.content}</div>
        }
    }

    render() {
        // Load content on init or update (parent could update state)
        return (
            <div className="luna-help-modal-wrapper">
                { this.getContent() }
            </div>
        )
    }
}